// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import { Card, Form, Row, Col, Spinner, Badge } from "react-bootstrap";
// import Select from 'react-select';
// import Swal from "sweetalert2";
// import { BASE_URL } from "../../services/Api";
// import { authHeader } from "../../services/auth-header";

// const BranchView = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { pointindex } = useParams();

//   const [branchData, setBranchData] = useState({
//     company: null,
//     branchname: "",
//     contactperson: "",
//     phoneno: "",
//     gstno: "",
//     email: "",
//     address: "",
//     country: null,
//     state: null,
//     city: null,
//     zipcode: "",
//     accountno: "",
//     bankname: "",
//     bankbranchname: "",
//     ifsccode: "",
//     statecode: ""
//   });

//   const [companyOptions, setCompanyOptions] = useState([]);
//   const [countryOptions, setCountryOptions] = useState([]);
//   const [stateOptions, setStateOptions] = useState([]);
//   const [cityOptions, setCityOptions] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchBranchDetails = async () => {
//       try {
//         const [branchResponse, companiesResponse, countriesResponse] = await Promise.all([
//           axios.get(`${BASE_URL}branch/findById/${id}`, { headers: authHeader() }),
//           axios.get(`${BASE_URL}company/findAllCompany`, { headers: authHeader() }),
//           axios.get(`${BASE_URL}country/findAllCountry`, { headers: authHeader() })
//         ]);

//         const branch = branchResponse.data;
//         const companies = companiesResponse.data;
//         const countries = countriesResponse.data;

//         setCompanyOptions(companies.map(c => ({ value: c.id, label: c.companyname })));
//         setCountryOptions(countries.map(c => ({ value: c.id, label: c.countryname })));

//         let states = [];
//         let cities = [];

//         if (branch.country) {
//           const statesResponse = await axios.get(
//             `${BASE_URL}state/stateByCountry/${branch.country.id}`,
//             { headers: authHeader() }
//           );
//           states = statesResponse.data;
//           setStateOptions(states.map(s => ({
//             value: s.id,
//             label: s.statename,
//             code: s.statecode
//           })));
//         }

//         if (branch.state) {
//           const citiesResponse = await axios.get(
//             `${BASE_URL}city/cityByStateId/${branch.state.id}`,
//             { headers: authHeader() }
//           );
//           cities = citiesResponse.data;
//           setCityOptions(cities.map(c => ({ value: c.id, label: c.cityname })));
//         }

//         setBranchData({
//           company: branch.company ? {
//             value: branch.company.id,
//             label: branch.company.companyname
//           } : null,
//           branchname: branch.branchname,
//           contactperson: branch.contactperson,
//           phoneno: branch.phoneno,
//           gstno: branch.gstno,
//           email: branch.email,
//           address: branch.address,
//           country: branch.country ? {
//             value: branch.country.id,
//             label: branch.country.countryname
//           } : null,
//           state: branch.state ? {
//             value: branch.state.id,
//             label: branch.state.statename,
//             code: branch.state.statecode
//           } : null,
//           city: branch.city ? {
//             value: branch.city.id,
//             label: branch.city.cityname
//           } : null,
//           zipcode: branch.zipcode,
//           accountno: branch.accountno,
//           bankname: branch.bankname,
//           bankbranchname: branch.bankbranchname,
//           ifsccode: branch.ifsccode,
//           statecode: branch.statecode || (branch.state ? branch.state.statecode : "")
//         });

//       } catch (error) {
//         Swal.fire({
//           icon: 'error',
//           title: 'Error',
//           text: 'Failed to fetch branch details. Please try again.',
//         });
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchBranchDetails();
//   }, [id]);

//   const getItem = (id) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios.delete(BASE_URL + "branch/delete/" + id, {
//           headers: authHeader(),
//         })
//           .then(response => {
//             if (response.data.length === 0) {
//               Swal.fire(
//                 'Warning',
//                 'Branch present in another module. Delete operation has been cancelled.',
//                 'warning'
//               );
//             } else {
//               navigate(`/branchindex/${pointindex}`);
//               Swal.fire(
//                 'Deleted!',
//                 'Branch deleted successfully.',
//                 'success'
//               );
//             }
//           })
//           .catch((error) => {
//             Swal.fire(
//               'Error',
//               error.response.data,
//               'error'
//             );
//           });
//       }
//     });
//   };

//   if (isLoading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//         <Spinner animation="border" variant="primary" />
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-md-12">
//           <Card className="shadow-sm">
//             <Card.Header className="d-flex justify-content-between align-items-center">
//               <h5 className="mb-0">
//                 <i className="fas fa-code-branch mr-2"></i>
//                 Branch Details
//               </h5>
//               <div>
//                 <button onClick={() => getItem(id)} className="button-70 btn-danger mr-2">
//                   <i className="fas fa-trash mr-1"></i> Delete
//                 </button>
//                 <Link to={`/branchEdit/${id}/${pointindex}`} className="button-70 btn-warning mr-2">
//                   <i className="fas fa-edit mr-1"></i> Edit
//                 </Link>
//                 <Link to={`/branchindex/${pointindex}`} className="button-70 btn-light">
//                   <i className="fas fa-arrow-left mr-1"></i> Back
//                 </Link>
//               </div>
//             </Card.Header>

//             <Card.Body>
//               <div className="mb-4">
//                 <h6 className="border-bottom pb-2 mb-3">
//                   <i className="fas fa-info-circle mr-2"></i>Basic Information
//                 </h6>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Branch Name</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.branchname || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Company</Form.Label>
//                       <Select
//                         value={branchData.company}
//                         options={companyOptions}
//                         isDisabled
//                         placeholder="Not specified"
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Contact Person</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.contactperson || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Mobile No</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.phoneno || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Email</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.email || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">GST No</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.gstno || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </div>

//               <div className="mb-4">
//                 <h6 className="border-bottom pb-2 mb-3">
//                   <i className="fas fa-map-marker-alt mr-2"></i>Address Details
//                 </h6>
//                 <Row>
//                   <Col md={12} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Address</Form.Label>
//                       <Form.Control
//                         as="textarea"
//                         rows={3}
//                         plaintext
//                         readOnly
//                         value={branchData.address || "N/A"}
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={4} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Country</Form.Label>
//                       <Select
//                         value={branchData.country}
//                         options={countryOptions}
//                         isDisabled
//                         placeholder="Not specified"
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={4} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">State</Form.Label>
//                       <Select
//                         value={branchData.state}
//                         options={stateOptions}
//                         isDisabled
//                         placeholder="Not specified"
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={4} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">State Code</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.statecode || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={4} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">City</Form.Label>
//                       <Select
//                         value={branchData.city}
//                         options={cityOptions}
//                         isDisabled
//                         placeholder="Not specified"
//                       />
//                     </Form.Group>
//                   </Col>
//                   <Col md={4} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Zip Code</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.zipcode || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </div>

//               <div className="mb-4">
//                 <h6 className="border-bottom pb-2 mb-3">
//                   <i className="fas fa-university mr-2"></i>Bank Details
//                 </h6>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Bank Name</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.bankname || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Account No.</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.accountno || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">Branch Name</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.bankbranchname || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group>
//                       <Form.Label className="font-weight-bold">IFSC Code</Form.Label>
//                       <Form.Control plaintext readOnly value={branchData.ifsccode || "N/A"} />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </div>
//             </Card.Body>

//             <Card.Footer className="bg-light">
//               <div className="d-flex justify-content-end">
//                 <Link to={`/branchindex/${pointindex}`} className="btn btn-secondary mr-2">
//                   <i className="fas fa-arrow-left mr-1"></i> Back to List
//                 </Link>
//                 <Link to={`/branchEdit/${id}/${pointindex}`} className="btn btn-primary">
//                   <i className="fas fa-edit mr-1"></i> Edit Branch
//                 </Link>
//               </div>
//             </Card.Footer>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BranchView;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, Form, Row, Col, Spinner } from "react-bootstrap";
import Select from 'react-select';
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const BranchView = () => {
  const { id, pointindex } = useParams();
  const navigate = useNavigate();

  const [branchData, setBranchData] = useState({
    company: null, branchname: "", contactperson: "", phoneno: "", gstno: "", email: "",
    address: "", country: null, state: null, city: null, zipcode: "",
    accountno: "", bankname: "", bankbranchname: "", ifsccode: "", statecode: ""
  });
  const [companyOptions, setCompanyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      try {
        const [branchResponse, companiesResponse, countriesResponse] = await Promise.all([
          axios.get(`${BASE_URL}branch/findById/${id}`, { headers: authHeader() }),
          axios.get(`${BASE_URL}company/findAllCompany`, { headers: authHeader() }),
          axios.get(`${BASE_URL}country/findAllCountry`, { headers: authHeader() })
        ]);
        const branch = branchResponse.data;
        setCompanyOptions(companiesResponse.data.map(c => ({ value: c.id, label: c.companyname })));
        setCountryOptions(countriesResponse.data.map(c => ({ value: c.id, label: c.countryname })));

        if (branch.country) {
          const statesResponse = await axios.get(`${BASE_URL}state/stateByCountry/${branch.country.id}`, { headers: authHeader() });
          setStateOptions(statesResponse.data.map(s => ({ value: s.id, label: s.statename, code: s.statecode })));
        }
        if (branch.state) {
          const citiesResponse = await axios.get(`${BASE_URL}city/cityByStateId/${branch.state.id}`, { headers: authHeader() });
          setCityOptions(citiesResponse.data.map(c => ({ value: c.id, label: c.cityname })));
        }

        setBranchData({
          company: branch.company ? { value: branch.company.id, label: branch.company.companyname } : null,
          branchname: branch.branchname, contactperson: branch.contactperson, phoneno: branch.phoneno,
          gstno: branch.gstno, email: branch.email, address: branch.address,
          country: branch.country ? { value: branch.country.id, label: branch.country.countryname } : null,
          state: branch.state ? { value: branch.state.id, label: branch.state.statename, code: branch.state.statecode } : null,
          city: branch.city ? { value: branch.city.id, label: branch.city.cityname } : null,
          zipcode: branch.zipcode, accountno: branch.accountno, bankname: branch.bankname,
          bankbranchname: branch.bankbranchname, ifsccode: branch.ifsccode,
          statecode: branch.statecode || (branch.state ? branch.state.statecode : "")
        });
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch branch details. Please try again.' });
      } finally {
        setIsLoading(false);
      }
    };
    fetchBranchDetails();
  }, [id]);

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?', text: "You won't be able to revert this!", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(BASE_URL + "branch/delete/" + id, { headers: authHeader() })
          .then(response => {
            if (response.data.length === 0) {
              Swal.fire('Warning', 'Branch present in another module. Delete operation has been cancelled.', 'warning');
            } else {
              navigate(`/branchindex/${pointindex}`);
              Swal.fire('Deleted!', 'Branch deleted successfully.', 'success');
            }
          })
          .catch((error) => {
            Swal.fire('Error', error.response?.data || 'Something went wrong', 'error');
          });
      }
    });
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  /* Reusable read-only field */
  const ReadField = ({ label, value }) => (
    <Form.Group className="mb-3">
      <Form.Label className="form-label">{label}</Form.Label>
      <Form.Control className="form-control" plaintext readOnly value={value || "N/A"}
        style={{ background: 'var(--gray-50)', borderRadius: 'var(--radius-base)', padding: '6px 12px' }} />
    </Form.Group>
  );

  return (
    <div className="container-fluid p-4">
      <Card className="brand-card">
        <Card.Header className="brand-header">
          <h6>BRANCH DETAILS</h6>
          <div className="d-flex gap-2">
            <button onClick={() => handleDelete(id)} className="button-70 btn-danger" type="button">
              DELETE
            </button>
            <Link to={`/branchEdit/${id}/${pointindex}`}>
              <button className="button-70" type="button">EDIT</button>
            </Link>
            <Link to={`/branchindex/${pointindex}`}>
              <button className="button-70" type="button">BACK</button>
            </Link>
          </div>
        </Card.Header>

        <Card.Body className="brand-body">

          {/* Basic Info */}
          <Card className="brand-card mb-4">
            <Card.Header className="brand-header">
              <h6>BASIC INFORMATION</h6>
            </Card.Header>
            <Card.Body className="brand-body">
              <Row>
                <Col md={6}><ReadField label="Branch Name" value={branchData.branchname} /></Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">Company</Form.Label>
                    <Select value={branchData.company} options={companyOptions} isDisabled placeholder="Not specified" />
                  </Form.Group>
                </Col>
                <Col md={6}><ReadField label="Contact Person" value={branchData.contactperson} /></Col>
                <Col md={6}><ReadField label="Mobile No." value={branchData.phoneno} /></Col>
                <Col md={6}><ReadField label="Email" value={branchData.email} /></Col>
                <Col md={6}><ReadField label="GST No." value={branchData.gstno} /></Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Address Details */}
          <Card className="brand-card mb-4">
            <Card.Header className="brand-header">
              <h6>ADDRESS DETAILS</h6>
            </Card.Header>
            <Card.Body className="brand-body">
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">Address</Form.Label>
                    <Form.Control as="textarea" rows={3} plaintext readOnly value={branchData.address || "N/A"}
                      className="custom-textarea" style={{ background: 'var(--gray-50)' }} />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">Country</Form.Label>
                    <Select value={branchData.country} options={countryOptions} isDisabled placeholder="Not specified" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">State</Form.Label>
                    <Select value={branchData.state} options={stateOptions} isDisabled placeholder="Not specified" />
                  </Form.Group>
                </Col>
                <Col md={4}><ReadField label="State Code" value={branchData.statecode} /></Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">City</Form.Label>
                    <Select value={branchData.city} options={cityOptions} isDisabled placeholder="Not specified" />
                  </Form.Group>
                </Col>
                <Col md={4}><ReadField label="Zip Code" value={branchData.zipcode} /></Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Bank Details */}
          <Card className="brand-card mb-4">
            <Card.Header className="brand-header">
              <h6>BANK DETAILS</h6>
            </Card.Header>
            <Card.Body className="brand-body">
              <Row>
                <Col md={6}><ReadField label="Bank Name" value={branchData.bankname} /></Col>
                <Col md={6}><ReadField label="Account No." value={branchData.accountno} /></Col>
                <Col md={6}><ReadField label="Branch Name" value={branchData.bankbranchname} /></Col>
                <Col md={6}><ReadField label="IFSC Code" value={branchData.ifsccode} /></Col>
              </Row>
            </Card.Body>
          </Card>

          <div className="d-flex justify-content-end gap-2 mt-2">
            <Link to={`/branchindex/${pointindex}`}>
              <button className="button-70" type="button">BACK TO LIST</button>
            </Link>
            <Link to={`/branchEdit/${id}/${pointindex}`}>
              <button className="button-70" type="button">EDIT BRANCH</button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BranchView;